<template>
  <div class="info-wrap">
    <div class="info-cont">
      <h1>
        <img src="@/assets/images/icon-myinfo-info.svg" alt="">
        사용자<br> 정보 수정
      </h1>
      <input-text :title="'아이디'" :contList="'info'" :defaultText="'아이디'" :modelValue="userData.userId" />
      <input-text :title="'회사명'" :contList="'info'" :modelValue="userData.userName" />
      <input-text :title="'연락처'" :contList="'info'" :modelValue="userData.phoneNumber" />
      <ui-select :title="'이메일 언어'" :contList="'info short'" :itemList="selectLanguageList" :modelValue="userData.displayLang"/>
      <ui-select :title="'표준 시간대'" :contList="'info'" :itemList="selectTimezoneList" :modelValue="'('+userData.timezone+') ' +userData.timezoneName" />
    </div>
    <div class="info-cont pwd">
      <h1>
        <img src="@/assets/images/icon-myinfo-lock.svg" alt="">
        비밀번호<br> 변경
      </h1>
      <div class="pwd-input">
        <input-text :title="'현재 비밀번호'" :contList="'info'"/>
        <input-text :title="'새 비밀번호'" :contList="'info'"/>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import InputText from '@/components/ui/InputText'
import UiSelect from '@/components/ui/UiSelect'
import { SELECT_LANGUAGE_LIST, SELECT_TIMEZONE_LIST } from '@/libs/constants'

export default {
  name: 'MyInfo',
  components: {
    InputText,
    UiSelect
  },
  data () {
    return {
      selectLanguageList: SELECT_LANGUAGE_LIST,
      selectTimezoneList: SELECT_TIMEZONE_LIST
    }
  },
  computed: {
    ...mapState([
      'userData'
    ])
  },
  created () {

  }
}
</script>

<style lang="scss" scoped="scoped">

.info-wrap {
  margin: 80px 0 200px;
  .info-cont {
    position: relative;
    width: 800px;
    height: 540px;
    border-radius: 14px;
    box-shadow: 0 23px 15px -12px rgba(0, 0, 0, 0.08), 0 0 0 1px rgba(0, 0, 0, 0.08);
    background: #fff;
    margin: 0 auto;
    box-sizing: border-box;
    padding: 50px 40px 50px 230px;
    h1 {
      position: absolute;
      top: 40px;
      left: 40px;
      font-size: 15px;
      font-weight: 500;
      line-height: 1.47;
      color: #2f2f2f;
      img {
        display: block;
        margin-bottom: 15px;
      }
    }
    &.pwd {
      height: 252px;
      margin: 30px auto 0;
      .pwd-input {
        width: 350px;
      }
    }
  }
}

</style>
